import { Component, ComponentRef, Input } from '@angular/core';
import { InputsType } from 'ng-dynamic-component';
import { BehaviorSubject } from 'rxjs';

import { DocumentBuilderPageDirective } from './document-builder-page.base.directive';

@Component({
    selector: 'la-document-builder-page',
    template: `
    <ndc-dynamic
      [ndcDynamicComponent]="component"
      [ndcDynamicInputs]="inputs"
      (ndcDynamicCreated)="onComponentCreated($event)"
    ></ndc-dynamic>
  `,
    standalone: false
})
export class DocumentBuilderPageComponent {
  @Input() component: any;
  @Input() inputs!: InputsType;

  dynamicPage$ = new BehaviorSubject<DocumentBuilderPageDirective | null>(null);

  onComponentCreated(component: ComponentRef<unknown>) {
    if (component.instance instanceof DocumentBuilderPageDirective) {
      this.dynamicPage$.next(component.instance);
    }
  }
}
